/**
 * Porto theme script and initialization script
 *
 * If you wish to manually initialize the theme without calling the initializeContainer function,
 * you can require `porto-admin/HTML/js/theme.init`
 *
 * Usage:
 * ```
 * import theme from "porto-admin/build/script/theme";
 *
 * theme.initializeContainer($container);
 * ```
 *
 */
// Require the theme vendors and basic theme functionality
require('./vendor');
require('../../HTML/js/theme');

/**
 * Initialization of a container, this function is a copy of init, but applies it only to the elements within a jQuery element
 *
 * @param {jQuery} [$container] - Container to initialize, defaults to `body`
 */
const initializeContainer = function($container) {
    $container = $container || $('body');

    //region Appear animation
    if ($.isFunction($.fn['appear'])) {
        $(function() {
            $container.find('[data-plugin-animate], [data-appear-animation]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginAnimate(opts);
            });
        });
    }
    //endregion

    //region Carousel
    if ($.isFunction($.fn['owlCarousel'])) {
        $(function() {
            $container.find('[data-plugin-carousel]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginCarousel(opts);
            });
        });
    }
    //endregion

    //region Pie chart
    if ($.isFunction($.fn['easyPieChart'])) {
        $(function() {
            $container.find('[data-plugin-chart-circular], .circular-bar-chart:not(.manual)').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }
                $this.themePluginChartCircular(opts);
            });
        });

    }
    //endregion

    //region Code mirror
    if (typeof CodeMirror !== 'undefined') {
        $(function() {
            $container.find('[data-plugin-codemirror]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginCodeMirror(opts);
            });
        });
    }
    //endregion

    //region Colorpicker
    if ($.isFunction($.fn['colorpicker'])) {

        $(function() {
            $container.find('[data-plugin-colorpicker]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginColorPicker(opts);
            });
        });

    }
    //endregion

    //region Datepicker
    if ($.isFunction($.fn['bootstrapDP'])) {
        $(function() {
            $container.find('[data-plugin-datepicker]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginDatePicker(opts);
            });
        });
    }
    //endregion

    //region iosSwitcher
    if (typeof Switch !== 'undefined' && $.isFunction(Switch)) {
        $(function() {
            $container.find('[data-plugin-ios-switch]').each(function() {
                let $this = $(this);

                $this.themePluginIOS7Switch();
            });
        });
    }
    //endregion

    //region Lightbox
    if ($.isFunction($.fn['magnificPopup'])) {
        $(function() {
            $container.find('[data-plugin-lightbox], .lightbox:not(.manual)').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }
                $this.themePluginLightbox(opts);
            });
        });
    }
    //endregion

    //region Portlets
    if (typeof NProgress !== 'undefined' && $.isFunction(NProgress.configure)) {
        NProgress.configure({
            showSpinner: false,
            ease:        'ease',
            speed:       750
        });
    }
    //endregion

    //region Markdown
    if ($.isFunction($.fn['markdown'])) {

        $(function() {
            $container.find('[data-plugin-markdown-editor]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginMarkdownEditor(opts);
            });
        });
    }
    //endregion

    //region Masked input
    if ($.isFunction($.fn['mask'])) {
        $(function() {
            $container.find('[data-plugin-masked-input]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginMaskedInput(opts);
            });
        });
    }
    //endregion

    //region MaxLength
    if ($.isFunction($.fn['maxlength'])) {
        $(function() {
            $container.find('[data-plugin-maxlength]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginMaxLength(opts);
            });
        });
    }
    //endregion

    //region Multiselect
    if ($.isFunction($.fn['multiselect'])) {
        $(function() {
            $container.find('[data-plugin-multiselect]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginMultiSelect(opts);
            });
        });
    }
    //endregion

    //region Placeholder
    if ($.isFunction($.fn['placeholder'])) {
        $container.find('input[placeholder]').placeholder();
    }
    //endregion

    //region Popover
    if ($.isFunction($.fn['popover'])) {
        $container.find('[data-toggle=popover]').popover();
    }
    //endregion

    //region Portlets
    $(function() {
        $container.find('[data-plugin-portlet]').each(function() {
            let $this = $(this),
                opts  = {};

            let pluginOptions = $this.data('plugin-options');
            if (pluginOptions) {
                opts = pluginOptions;
            }
            $this.themePluginPortlet(opts);
        });
    });
    //endregion

    //region Scroll to top
    if (typeof window.theme.PluginScrollToTop !== 'undefined') {
        window.theme.PluginScrollToTop.initialize();
    }
    //endregion

    //region Scrollable
    if ($.isFunction($.fn['nanoScroller'])) {
        $(function() {
            $container.find('[data-plugin-scrollable]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginScrollable(opts);
            });
        });
    }
    //endregion

    //region Select2
    if ($.isFunction($.fn['select2'])) {
        $(function() {
            $container.find('[data-plugin-selectTwo], [data-plugin-select-two]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }
                // Allow to set dropdown parent through json data plugin options attribute
                if (typeof opts.dropdownParent === 'string') {
                    opts.dropdownParent = $(opts.dropdownParent);
                }
                // When setting modal container to a modal, the dropdown will work correctly
                if ($this.closest('.modal-container').length === 1) {
                    opts.dropdownParent = $this.closest('.modal-container');
                }

                $this.themePluginSelect2(opts);
            });
        });
    }
    //endregion

    //region Sidebar widgets
    function expand(content) {
        content.children('.widget-content').slideDown('fast', function() {
            $(this).css('display', '');
            content.removeClass('widget-collapsed');
        });
    }

    function collapse(content) {
        content.children('.widget-content').slideUp('fast', function() {
            content.addClass('widget-collapsed');
            $(this).css('display', '');
        });
    }

    let $widgets = $container.find('.sidebar-widget');
    $widgets.each(function() {
        let $widget  = $(this),
            $toggler = $widget.find('.widget-toggle');

        $toggler.on('click.widget-toggler', function() {
            $widget.hasClass('widget-collapsed') ? expand($widget) : collapse($widget);
        });
    });
    //endregion

    //region Slider
    if ($.isFunction($.fn['slider'])) {
        $(function() {
            $container.find('[data-plugin-slider]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginSlider(opts);
            });
        });
    }
    //endregion

    //region Spinner
    if ($.isFunction($.fn['spinner'])) {
        $(function() {
            $container.find('[data-plugin-spinner]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginSpinner(opts);
            });
        });
    }
    //endregion

    //region SummerNote
    if ($.isFunction($.fn['summernote'])) {
        $(function() {
            $container.find('[data-plugin-summernote]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginSummerNote(opts);
            });
        });
    }
    //endregion

    //region TextArea AutoSize
    if (typeof window.autosize === 'function') {
        $(function() {
            $container.find('[data-plugin-textarea-autosize]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginTextAreaAutoSize(opts);
            });
        });
    }
    //endregion

    //region TimePicker
    if ($.isFunction($.fn['timepicker'])) {
        $(function() {
            $container.find('[data-plugin-timepicker]').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginTimePicker(opts);
            });
        });
    }
    //endregion

    //region Toggle
    $(function() {
        $container.find('[data-plugin-toggle]').each(function() {
            let $this = $(this),
                opts  = {};

            let pluginOptions = $this.data('plugin-options');
            if (pluginOptions) {
                opts = pluginOptions;
            }

            $this.themePluginToggle(opts);
        });
    });
    //endregion

    //region Tooltip
    if ($.isFunction($.fn['tooltip'])) {
        $container.find('[data-toggle=tooltip],[rel=tooltip]').tooltip({container: 'body'});
    }
    //endregion

    //region Widget
    if ($.isFunction($.fn['themePluginWidgetTodoList'])) {
        $(function() {
            $container.find('[data-plugin-todo-list], ul.widget-todo-list').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginWidgetTodoList(opts);
            });
        });
    }
    //endregion

    //region Widget - Toggle
    if ($.isFunction($.fn['themePluginWidgetToggleExpand'])) {
        $(function() {
            $container.find('[data-plugin-toggle-expand], .widget-toggle-expand').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginWidgetToggleExpand(opts);
            });
        });
    }
    //endregion

    //region Word rotator
    if ($.isFunction($.fn['themePluginWordRotator'])) {
        $(function() {
            $container.find('[data-plugin-wort-rotator], .wort-rotator:not(.manual)').each(function() {
                let $this = $(this),
                    opts  = {};

                let pluginOptions = $this.data('plugin-options');
                if (pluginOptions) {
                    opts = pluginOptions;
                }

                $this.themePluginWordRotator(opts);
            });
        });
    }
    //endregion

    //region Mailbox
    $(function() {
        $container.find('[data-mailbox]').each(function() {
            let $this = $(this);
            $this.themeMailbox();
        });
    });
    //endregion

    //region Navigation
    let $window     = $(window);
    let toggleClass = function($el) {
        if (!!$el.data('toggleClassBinded')) {
            return false;
        }
        let $target,
            className,
            eventName;
        $target   = $($el.attr('data-target'));
        className = $el.attr('data-toggle-class');
        eventName = $el.attr('data-fire-event');

        $el.on('click.toggleClass', function(e) {
            e.preventDefault();
            $target.toggleClass(className);
            let hasClass = $target.hasClass(className);

            if (!!eventName) {
                $window.trigger(eventName, {
                    added:   hasClass,
                    removed: !hasClass
                });
            }
        });

        $el.data('toggleClassBinded', true);
        return true;
    };
    $(function() {
        $container.find('[data-toggle-class][data-target]').each(function() {
            toggleClass($(this));
        });
    });
    //endregion
};

// Export this for module usage
export default {
    initializeContainer: initializeContainer
};



// WEBPACK FOOTER //
// ./node_modules/porto-admin/build/script/theme.js